export default __webpack_public_path__ + "static/media/footer.ec3639df.gif";